import React from 'react'

class ListRowProcessed extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            invoice: props.invoice,
            invoiceItem: props.invoiceItem,
            rule: props.rule,
            company: props.company
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        return {
            invoice: nextProps.invoice,
            invoiceItem: nextProps.invoiceItem,
            rule: nextProps.rule,
        }
    }

    render() {
        return (
            <tr>
                <td>{this.state.invoiceItem.name}</td>
                <td>{this.state.rule.main_bookkeeping_number}</td>
                <td>{parseInt(this.state.invoiceItem.vat, 0)}%</td>
                <td>{this.state.rule.vatCollectorCode ? this.state.rule.vatCollectorCode.code : null}</td>
                <td>{this.state.invoice.tax_number}</td>
                <td>{this.state.invoice.city}</td>
                <td>{this.state.invoice.company_name}</td>
                <td>{this.state.invoice.paymentMethodLabel}</td>
                <td>{this.state.invoice.invoiceNumber}</td>
                <td>{this.state.rule.vat_degree}</td>
            </tr>
        )
    }
}

export default ListRowProcessed


// WEBPACK FOOTER //
// ./src/components/customer/steps/assignment/ListRowProcessed.js